import './App.css';

import { useState, useEffect } from 'react';
import { RequireAuth } from './components/RequireAuth';
import { Route, Routes } from 'react-router-dom';
import Layout from './pages/Layout';
import Register from './pages/Register';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Notifications from './pages/Notifications';
import NewNotification from './pages/NewNotification';
import { NotFound } from './pages/NotFound';
import { NotAuthorized } from './pages/NotAuthorized';

function App() {
  const [notifications, setNotifications] = useState([])
  const [search, setSearch] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
  const filteredResults = notifications.filter((notification) =>
    ((notification.notificationText).toLowerCase()).includes(search.toLowerCase()));

    setSearchResults(filteredResults);
  }, [notifications, search])

  return (
    <Routes>
      <Route path="/" >
        {/* public routes  */}
        <Route index element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="logout" element={<Logout />} />
        <Route path="login" element={<Login />} />
      </Route>

      <Route path="/" element={<Layout />}>
        <Route path="notauthorized" element={<NotAuthorized />} />

        {/* protected routes  */}
        <Route element={<RequireAuth />}>
          <Route path="notifications"
          element={<Notifications
            notifications={searchResults}
            setNotifications={setNotifications}
            search={search}
            setSearch={setSearch}
            />
          }
          />
          <Route path="new" element={<NewNotification setNotifications={setNotifications}/>} />
        </Route>

        {/* catch all  */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;